module.exports = __webpack_public_path__ + "static/media/noise.31443fe8.mp4";